import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { SedsAvatarModule } from '../../seds-avatar';
import { SedsHeaderUserComponent } from './seds-header-user.component';

@NgModule({
  declarations: [SedsHeaderUserComponent],
  imports: [CommonModule, SedsAvatarModule, MatButtonModule, MatIconModule, MatMenuModule],
  exports: [SedsHeaderUserComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SedsHeaderUserModule {}
